<template>
    <div>
        <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline">
            <h4>Regions</h4>
            <button @click="newRegion"
                    :disabled="loading"
                    class="btn btn-primary">
                New region
            </button>
        </div>
        <VueGoodTable :columns="columns"
                      :rows="regions"
                      @on-row-click="viewRegion"
                      :isLoading.sync="loading"
                      :pagination-options="{
                        enabled: true,
                      }"
                      styleClass="vgt-table condensed"
                      class="vgt-table--card"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VueGoodTable } from 'vue-good-table';

export default {
  components: {
    VueGoodTable,
  },
  computed: {
    ...mapGetters({
      regions: 'regions/regions',
    }),
  },
  data() {
    return {
      loading: false,
      columns: [],
    };
  },
  mounted() {
    this.columns = [
      {
        label: 'Name',
        field: 'name',
        filterOptions: {
          enabled: true,
        },
      },
    ];
    this.getRegions();
  },
  methods: {
    newRegion() {
      this.$router.push({
        name: 'region',
        params: { id: 'new' },
      });
    },
    getRegions() {
      this.loading = true;

      this.$store.dispatch('regions/getRegions')
        .finally(() => {
          this.loading = false;
        });
    },
    viewRegion(event) {
      this.$router.push({
        name: 'region',
        params: { id: event.row.id },
      });
    },
    updateParams(props) {
      this.$store.commit('companies/queryProps', props);
    },
  },
};
</script>
